const SvgCheck = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <path d="m28 9.332-16 16L4.668 18l1.879-1.879L12 21.56 26.121 7.453Zm0 0" />
  </svg>
);
export default SvgCheck;
